import { useTranslation } from 'react-i18next';
import U2000BasicDialog from '../../u2000Core/components/dialog/U2000BasicDialog';
import { NS } from '../U3121';
import type { U3121LandRegisterCoverageLot } from '../U3121Service';

interface U3121CreateLandRegisterLotsDialogProps {
  isOpen: boolean;
  pendingLots: U3121LandRegisterCoverageLot[];
  isCreating?: boolean;
  onClose: () => void;
  onCreate: (lot: string) => void;
}

function U3121CreateLandRegisterLotsDialog({
  isOpen,
  pendingLots,
  isCreating = false,
  onClose,
  onCreate,
}: U3121CreateLandRegisterLotsDialogProps) {
  const { t } = useTranslation();

  return (
    <U2000BasicDialog isOpen={isOpen} onClose={isCreating ? () => {} : onClose} title={t('dlgCreateLandRegisterTitle', { ns: NS })} width="medium">
      <div className="space-y-4 px-6 py-4">
        <p className="text-sm text-gray-700">{t('dlgCreateLandRegisterIntro', { ns: NS })}</p>
        {pendingLots.length === 0 ? (
          <p className="text-sm text-gray-500">{t('msgCreateLandRegisterNoPendingLots', { ns: NS })}</p>
        ) : (
          <ul className="divide-y divide-gray-200 rounded-lg border border-gray-200">
            {pendingLots.map((entry) => (
              <li key={entry.lot} className="flex items-center justify-between gap-3 px-4 py-3">
                <span className="text-sm font-medium text-gray-900">{entry.lot}</span>
                <button
                  type="button"
                  className="shrink-0 rounded-lg bg-primary-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-primary-700 disabled:cursor-not-allowed disabled:opacity-60"
                  disabled={isCreating}
                  onClick={() => onCreate(entry.lot)}
                >
                  {t('btnCreateLandRegisterRow', { ns: NS })}
                </button>
              </li>
            ))}
          </ul>
        )}
        <div className="flex justify-end pt-2">
          <button
            type="button"
            className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium hover:bg-gray-50"
            disabled={isCreating}
            onClick={onClose}
          >
            {t('btnClose', { ns: NS })}
          </button>
        </div>
      </div>
    </U2000BasicDialog>
  );
}

export default U3121CreateLandRegisterLotsDialog;
